import { useCallback, useContext } from 'react';
import type { Toast } from '@/types/components/common/toast';
import { ToastContext } from '@/components/common/toast/context';

export const useToast = () => {
    const context = useContext(ToastContext);

    if (!context) {
        throw new Error('useToast must be used within a ToastProvider');
    }

    return useCallback(
        (props: Omit<Toast, 'id'>) => {
            context.addToast(props);
        },
        [context]
    );
};